import Scrollbar from 'smooth-scrollbar'
import Flickity from 'flickity'
import { $, $1, each } from '../util'

const ScrollViewer = (() => {
  const initEvents = () => {
    const scrollViewer = $('.c-scroll-viewer')

    each(scrollViewer, (i, viewer) => {
      const imageSlider = $1('.c-scroll-viewer__image-slider')
      const slider = $1('.c-scroll-viewer__main-slider')
      const items = viewer.querySelectorAll('.c-scroll-viewer__item')

      const imageSliderInstance = new Flickity(imageSlider, {
        cellSelector: '.c-scroll-viewer__image-slide',
        draggable: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      })

      const sliderInstance = new Flickity(slider, {
        cellSelector: '.c-scroll-viewer__main-slide',
        draggable: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      })

      each(items, (l, item) => {
        item.addEventListener('click', function() {
          const index = parseInt(this.dataset.index, 10)
          each(items, (k, it) => it.classList.remove('is-active'))

          this.classList.add('is-active')
          console.log(index)
          imageSliderInstance.select(index)
          sliderInstance.select(index)
        })
      })
    })
  }

  const init = () => {
    const scrollViewer = $('.c-scroll-viewer')

    if (scrollViewer.length) {
      Scrollbar.initAll({
        alwaysShowTracks: true,
      })

      initEvents()
    }
  }

  return {
    init,
  }
})()

export default ScrollViewer
